/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { saveAs } from 'file-saver';
import contentDisposition from 'content-disposition';
import { getFormattedDisplay } from 'blb-utils/date';
import { baseRequest } from 'blb-api/baseRequest';
export const getDocumentsDisplayInfo = document => {
  return {
    timeDisplay: getFormattedDisplay(document.sentOn),
    uploaderName: document?.uploaderName
  };
};
export const removeExtensionFromFileName = doc => doc.extension ? doc.fileName.replace(`.${doc.extension}`, '') : doc.fileName;
export const removeExtensionFromString = docName => docName.replace(/\.[^/.]+$/, '');
export const downloadFileFromAPI = async (fileUrl, documentTypeLabel) => {
  const res = await baseRequest.get(fileUrl, {
    params: {
      documentTypeLabel
    },
    responseType: 'blob'
  });
  const parsedContentDispositionHeader = contentDisposition.parse(res.headers['content-disposition']);
  saveAs(new Blob([res.data]), parsedContentDispositionHeader.parameters.filename);
};